//src/pages/myprofile/MakeMyDashboard.jsx
import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/Dashboard.css';
import DashboardGridData from '../../components/DashboardGridData';

const MakeMyDashboard = () => {
  const [selectedModules, setSelectedModules] = useState([]);
  const modulesToExclude = [0, 1, 2, 4, 7, 17]; // Indexes of modules to exclude
  const maxSelectionLimit = 10;

  const handleCheckboxChange = (module) => {
    const isModuleSelected = selectedModules.includes(module);
    if (isModuleSelected) {
      setSelectedModules(prevSelectedModules =>
        prevSelectedModules.filter(selectedModule => selectedModule !== module)
      );
    } else {
      if (selectedModules.length < maxSelectionLimit) {
        setSelectedModules(prevSelectedModules => [...prevSelectedModules, module]);
      } else {
        return;
      }
    }
  };

  const handleProceed = () => {
    // console.log("Proceeding with selected modules:", selectedModules);
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <div className="dashboard-header">
          <h3 style={{ color: 'white' }}>Make My Dashboard</h3>
        </div>
      </div>
      <div className="dashboard ml-4 mr-4 text-center" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
          {selectedModules.length > 0 && (
            <div className="ml-20 mr-20 text-center" style={{ textAlign: 'center', marginTop: '20px' }}>
              <p className='text-white'>
                <strong>Selected Modules <span className='text-orange-500'>{selectedModules.length} out of {maxSelectionLimit}</span>:</strong>
                {selectedModules.map(module => module.title).join(', ')}
                {selectedModules.length >= maxSelectionLimit && (
                  <span style={{ color: 'red' }}> You have reached the maximum allowed selection of {maxSelectionLimit}.</span>
                )}
              </p>
              <button className="mt-4" onClick={handleProceed} style={{ padding: '10px 20px', width: "500px", backgroundColor: 'yellow', color: 'darkblue', borderRadius: '5px', border: 'none' }}>
                Proceed with the above Selections to Make Your Dashboard
              </button>
            </div>
          )}
        </div>
        <div className="dashboard" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
          {DashboardGridData.map((module, index) => (
            <div key={index} className="module" style={{ textAlign: 'center', margin: '15px' }}>
              <div>
                <img src={module.imageUrl} alt={module.title} width="130" height="88" style={{ marginBottom: '10px' }} />
              </div>
              <div className="module-title" style={{ color: 'white', fontSize: '12px' }}>
                <label htmlFor={`app-${index}`}>
                  <input
                    type="checkbox"
                    name="app"
                    id={`app-${index}`}
                    checked={selectedModules.includes(module)}
                    onChange={() => handleCheckboxChange(module)}
                    className="checkbox-input mr-1"
                    style={{ marginBottom: '10px' }}
                    disabled={modulesToExclude.includes(index)}
                  />
                  {module.title}
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}

export default MakeMyDashboard;


